<template>
  <b-row align-h="center">
    <PageHeader :title="title" :items="items"/>
    <b-col md="12" xl="10" lg="12" sm="12">
      <b-card>
        <b-card-body class="p-0">
          <form-wizard color="#556ee6"
                       errorColor="#f46a6a"
                       transition="fade"
                       ref="wizard"
                       :nextButtonText="$t('pages.campaign.new_campaign.next_btn')"
                       :backButtonText="$t('pages.campaign.new_campaign.back_btn')"
          >
            <tab-content icon="mdi mdi-tune" lazy :before-change="()=>validateStep('step1')">
              <b-row>
                <b-col sm="5" class="place-center">
                  <b-card-img :src="require('@/assets/images/campaign.svg')" class="rounded-0"></b-card-img>
                </b-col>
                <b-col sm="7">
                  <campaign-detail ref="step1" @on-validate="mergePartialModels"></campaign-detail>
                </b-col>
              </b-row>
            </tab-content>
            <tab-content icon="mdi mdi-alarm-check" lazy :before-change="()=>validateStep('step2')">
              <b-row>
                <b-col sm="5" class="place-center">
                  <b-card-img :src="require('@/assets/images/schedule.svg')" class="rounded-0"></b-card-img>
                </b-col>
                <b-col sm="7">
                  <campaign-schedule ref="step2" @on-validate="mergePartialModels"></campaign-schedule>
                </b-col>
              </b-row>
            </tab-content>
            <tab-content icon="mdi mdi-filter" lazy :before-change="()=>validateStep('step3')">
              <b-row>
                <b-col sm="5" class="place-center">
                  <b-card-img :src="require('@/assets/images/campaign-filter.svg')" class="rounded-0"></b-card-img>
                </b-col>
                <b-col sm="7">
                  <campaign-filter ref="step3" @on-validate="mergePartialModels"></campaign-filter>
                </b-col>
              </b-row>
            </tab-content>
            <tab-content icon="mdi mdi-monitor-share" lazy>
              <campaign-summary :final-model="finalModel" v-if="finalTab"></campaign-summary>
            </tab-content>

            <template #finish>
              <b-btn variant="success" :disabled="loading" @click="save">
                <b-spinner v-if="loading" small class="mx-1"></b-spinner>
                <i class="mdi mdi-content-save"></i>
                {{ $t('pages.campaign.new_campaign.last_btn') }}
              </b-btn>
            </template>

          </form-wizard>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import CampaignDetail from "./NewCampaign/CampaignDetail";
import CampaignSchedule from "./NewCampaign/CampaignSchedule";
import CampaignFilter from "./NewCampaign/CampaignFilter";
import CampaignService from "../../../../Services/Api/CampaignService";
import CampaignSummary from "./NewCampaign/CampaignSummary";
import QuotaAlert from "../../../../mixins/QuotaAlert";

export default {
  name: "NewCampaign",
  components: {CampaignSummary, CampaignFilter, CampaignSchedule, CampaignDetail, FormWizard, TabContent},
  mixins: [QuotaAlert],
  page() {
    return {
      title: this.$t('pages.campaign.new_campaign.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      title: this.$t('pages.campaign.new_campaign.title'),
      items: [
        {
          text: this.$t('pages.campaign.new_campaign.items.first'),
          href: "/campaigns",
        },
        {
          text: this.$t('pages.campaign.new_campaign.items.second'),
          active: true,
        },
      ],
      finalModel: {},
      finalTab: false,
      loading: false
    }
  },
  methods: {
    validateStep(name) {
      if (name === 'step3') {
        this.finalTab = true
      }
      const step = this.$refs[name];
      return step.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model)
      }
    },
    async save() {
      this.loading = true
      const payload = {
        name: this.finalModel.name,
        marketplaces: this.finalModel.selectedMarketplaces
            ? this.finalModel.selectedMarketplaces.map(x => x.marketplace_id)
            : [],
        template_id: this.finalModel.selectedTemplate.id,
        after: this.finalModel.afterThis,
        after_day: this.finalModel.afterDay,
        at_time: this.finalModel.time,
        buyer_count: this.finalModel.purchaseCount,
        status: this.finalModel.status,
        excludes: this.finalModel.excludeFilters,
        includes: this.finalModel.includeFilters
      }
      await CampaignService.store({payload}).then(() => {
        this.$store.dispatch('quota/getSubscriptionQuota')
        this.$router.push({name: 'campaigns'})
      }).catch(e => {
        if (e.status === 402) {
          this.showQuotaError()
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.place-center {
  align-self: center;
}

/deep/.wizard-progress-with-circle {
  background: #F0EFEA;
}


</style>